var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSpotlight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03155 11.87C-0.554573 8.22085 0.849962 3.9624 4.29585 1.97292V1.97292C7.16049 0.319021 10.7556 0.644793 13.2763 2.78669L20 8.49997L20 21L4.99997 21L1.03155 11.87Z",
    fill: "url(#paint0_linear_14039_15054)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58341 5.1665H10.4167V7.23317H9.58341V5.1665ZM12.3697 8.03749L13.831 6.57666L14.4201 7.16583L12.9589 8.62708L12.3697 8.03749ZM13.7667 10.5832H15.8333V11.4165H13.7667V10.5832ZM12.3722 13.9598L12.9613 13.3706L14.4226 14.8319L13.8334 15.4206L12.3722 13.9598ZM9.58341 14.7664H10.4167V16.8331H9.58341V14.7664ZM5.58179 14.8341L7.04345 13.3729L7.63262 13.9621L6.17137 15.4233L5.58179 14.8341ZM4.16675 10.5832H6.23341V11.4165H4.16675V10.5832ZM5.57918 7.16778L6.16877 6.57861L7.63002 8.03986L7.04085 8.62903L5.57918 7.16778ZM10.0001 9.33317C10.9206 9.33317 11.6667 10.0794 11.6667 10.9998C11.6667 11.9203 10.9206 12.6665 10.0001 12.6665C9.07961 12.6665 8.33341 11.9203 8.33341 10.9998C8.33341 10.0794 9.07961 9.33317 10.0001 9.33317V9.33317ZM10.0001 8.49984C8.61937 8.49984 7.50008 9.61913 7.50008 10.9998C7.50008 12.3805 8.61937 13.4998 10.0001 13.4998C11.3808 13.4998 12.5001 12.3805 12.5001 10.9998C12.5001 9.61913 11.3808 8.49984 10.0001 8.49984Z",
    fill: "#161616"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14039_15054",
    x1: 4,
    y1: 2,
    x2: 13.5,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AA56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.870713,
    stopColor: "#F1AA56",
    stopOpacity: 0
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSpotlight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spotlight.05f6bf72ed90549e2d7ac3f12d539787.svg";